import { render, staticRenderFns } from "./aiserviceadd.vue?vue&type=template&id=b5a7fcd8"
import script from "./aiserviceadd.vue?vue&type=script&lang=js"
export * from "./aiserviceadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports